export async function loadStarShape(engine, refresh = true) {
    const { StarDrawer } = await import("./StarDrawer.js");
    await engine.addShape("star", new StarDrawer(), refresh);
}
